import requests from "./httpService";

const PerformanceService = {
  getPerformancePeriod(id, body) {
    return requests.get(`/performanceperiod/all?company_id=${id}`, body);
  },
  createPerformancePeriod(body) {
    return requests.post(`/performanceperiod/create`, body);
  },
  updatePerformancePeriod(id, body) {
    return requests.post(`/performanceperiod/update/${id}`, body);
  },
  statusPerformancePeriod(id, comid, body) {
    return requests.post(
      `/performanceperiod/statusupdate/${id}?company_id=${comid}`,
      body
    );
  },
  deletePerformancePeriod(id, body) {
    return requests.delete(`/leavesession/${id}`, body);
  },
};

export default PerformanceService;
